import {
    SET_ID,
    SET_ADDRESS,
    SET_NAME,
    SET_ARRIVAL_INFO,
    SET_ROOM_INFO,
    SET_RESERVE_REMARK,
    SET_START_DAY,
    SET_END_DAY,
    SET_DAYS,
    SET_TOTALPRICE
} from '@/action-types/book'
interface Action {
    type: string,
    id: '',
    address: '',
    name: '',
    arrival_info: any[],
    room_info: any,
    reserve_remark: '',
    start_day: '',
    end_day: '',
    days: '',
    totalPrice: '',
}
const initDepotState = {
    id: '',
    address: '',
    name: '',
    arrival_info: [],
    room_info: {},
    reserve_remark: '',
    start_day: '',
    end_day: '',
    days: '',
    totalPrice: '',
}
const book = (state: {} = initDepotState, action: Action) => {
    switch (action.type) {
        case SET_ID:
            return Object.assign({}, state, { id: action.id })
        case SET_ADDRESS:
            return Object.assign({}, state, { address: action.address })
        case SET_NAME:
            return Object.assign({}, state, { name: action.name })
        case SET_ARRIVAL_INFO:
            return Object.assign({}, state, { arrival_info: action.arrival_info })
        case SET_ROOM_INFO:
            return Object.assign({}, state, { room_info: action.room_info })
        case SET_RESERVE_REMARK:
            return Object.assign({}, state, { reserve_remark: action.reserve_remark })
        case SET_START_DAY:
            return Object.assign({}, state, { start_day: action.start_day })
        case SET_END_DAY:
            return Object.assign({}, state, { end_day: action.end_day })
        case SET_DAYS:
            return Object.assign({}, state, { days: action.days })
        case SET_TOTALPRICE:
            return Object.assign({}, state, { totalPrice: action.totalPrice })
        default:
            return state
    }
}
export { book }